import { JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../base-types";

@JsonObject()
export class EntityPath {
    @JsonProperty("values")
    values: MapCultureTo<string>;

    @JsonProperty("entity")
    entity: string;

    @JsonProperty("definition")
    definition: string;
}
